<ion-card>
    <!--    <ion-fab vertical="center" horizontal="end">-->
    <!--        <ion-fab-button (tap)="display = !display;" size="small" color="light">-->
    <!--            <ion-icon [name]="display ? 'cancel' : 'add'"></ion-icon>-->
    <!--        </ion-fab-button>-->
    <!--    </ion-fab>-->
    <ion-card-content class="ion-no-margin">
        <ion-item>
            <ion-label position="floating">Job Type</ion-label>
            <ion-select interface="popover" [(ngModel)]="jobTypeId"
                        (ionChange)="updateJobType($event)" >
                <ion-select-option [value]="jobType.id"
                                   *ngFor="let jobType of jobTypeList">{{jobType.description}}</ion-select-option>
            </ion-select>
        </ion-item>

        <ion-item>
            <ion-label position="floating">Job Status</ion-label>
            <ion-select [(ngModel)]="jobStatus" interface="popover"
                        (ionChange)="updateJobStatus($event)" >
                <ion-select-option [value]="jobStatus.id"
                                   *ngFor="let jobStatus of jobStatusList">{{jobStatus.description}}</ion-select-option>
            </ion-select>
        </ion-item>

        <ion-item>
            <ion-label position="floating">Engineer</ion-label>
            <ion-select interface="popover"
                        (ionChange)="updateEngineer($event)" [selectedText]="document.serviceJob.engineer.name">
                <ion-select-option [value]="eng" *ngFor="let eng of engineerList">{{eng.name}}</ion-select-option>
            </ion-select>
        </ion-item>
    </ion-card-content>
</ion-card>
